import {createContext} from 'react';

import {SequenceType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {SchemaValidationStatus} from 'schemas/SchemaValidationConstants';

import {SmartChipType} from './SmartChipTypes';

interface BaseChipSnapshotData {
  id: string;
  name?: string | null;
  url?: string | null;
  isInaccessible: boolean;
  isArchived?: boolean | null;
  archivePurpose?: string | null;
  secondaryText?: string | null;
}

export interface StorableChipSnapshotData extends BaseChipSnapshotData {
  chipType: SmartChipType.STORABLE;
  storableSchemaIconId?: string | null;
  isExpired?: boolean | null;
  checkOutStatus?: string | null; // CheckOutStatus enum value (not boolean)
  restrictionStatus?: string | null; // RestrictionStatus enum value
  isCurrentUserAuthorized?: boolean | null;
}

export interface EntryChipSnapshotData extends BaseChipSnapshotData {
  chipType: SmartChipType.ENTRY;
  humanId?: string | null; // EntryChip secondary text (ELN_ENABLE_IDS_IN_ENTRY_CHIPS)
}

export interface BioentityChipSnapshotData extends BaseChipSnapshotData {
  chipType: SmartChipType.BIOENTITY;
  tagSchemaIconId?: string | null;
  sequenceType?: SequenceType | null;
  schemaValidationStatus?: SchemaValidationStatus | null;
  includeRegistryIdInChips?: boolean | null;
}

export interface GenericChipSnapshotData extends BaseChipSnapshotData {
  chipType: Exclude<SmartChipType, SmartChipType.STORABLE | SmartChipType.ENTRY | SmartChipType.BIOENTITY>;
}

export type ChipSnapshotData =
  | StorableChipSnapshotData
  | EntryChipSnapshotData
  | BioentityChipSnapshotData
  | GenericChipSnapshotData;

export const SmartChipSnapshotContext = createContext<ReadonlyMap<string, ChipSnapshotData> | null>(null);
